import { create } from 'zustand';

/**
 * 새 배포 버전 감지 상태.
 * useVersionCheck가 version.json 폴링으로 새 버전을 감지하면 markNewVersion을 호출하고,
 * UpdateBanner(useVersionCheck 훅 경유)와 NavigationReloadGate가 이 상태를 구독한다.
 */
interface VersionState {
  hasNewVersion: boolean;
  newVersion: string | null;
  markNewVersion: (v: string) => void;
}

export const useVersionStore = create<VersionState>((set) => ({
  hasNewVersion: false,
  newVersion: null,
  markNewVersion: (v) => set({ hasNewVersion: true, newVersion: v }),
}));
